import { getDocs, collection, getCountFromServer } from "firebase/firestore";

import { db } from "../firebase/config.js";

export async function getAllCommunities() {
    try {
        const querySnapshot = await getDocs(collection(db, "communities"));
        const allCommunities = []
        querySnapshot.forEach((doc) => {
            allCommunities.push({ id: doc.id, ...doc.data() })
        });
        return { success: true, communities: allCommunities };
    } catch (error) {
        console.error('Error getting request:', error);
        return { success: false, error: error.message };
    }
}

export async function getCommunitiesCount() {
    try {
        const coll = collection(db, "communities");
        const snapshot = await getCountFromServer(coll);
        const count = snapshot.data().count
        return { success: true, count };
    } catch (error) {
        console.error('Error getting count:', error);
        return { success: false, error: error.message };
    }
}